
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gsu5KptXjDkxhMJCjQmbHrkY1g8Yfh0re_8Lc7_EpieUMeta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexxhsPKdyuzTjE89SISJw2uruITDFs8_1pYUL35NbvbmoMeta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchJfZSnh1heKEZbJA_pftg3NDzXM19aajwGke3IwzSTuwMeta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexEWswwkedDA_458ixIsUwziYH0PLpFY7NXJQl_45cVb6qUrYMeta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93nrsZD444YV58kUOtkjce6JygYiAoO9lKMnWCcJYxudIMeta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index8WG5hLvjbseEx9ylS_45V2EtvNJSRty8hdFVfPdyXYKxEMeta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93HA4_45zO7U_456msvpYOdqytbWv7gK9UXqHL1uNFi795FocMeta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexua7qJxJ2AxRXxNSilBh9UJuU_45kgRT9TDlUJ69ytO19oMeta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93uQ5_V8HbZUN3AasIbiMDE5A_45WdvjtERkDr_451_45B0Qnd0Meta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexUYBHhT3iBXlFgw0qZ7Fnl50GM5vAIUdEbgAVNh9EA94Meta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index5rrPnD4btLlf5CtDogsrnrlN7b9jA8__45EQpLkeM5xU0Meta } from "/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index8WG5hLvjbseEx9ylS_45V2EtvNJSRty8hdFVfPdyXYKxEMeta || {},
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexua7qJxJ2AxRXxNSilBh9UJuU_45kgRT9TDlUJ69ytO19oMeta || {},
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexUYBHhT3iBXlFgw0qZ7Fnl50GM5vAIUdEbgAVNh9EA94Meta || {},
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index5rrPnD4btLlf5CtDogsrnrlN7b9jA8__45EQpLkeM5xU0Meta || {},
    component: () => import("/codebuild/output/src4041005183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]